import { onMounted, ref, watch } from "@vue/composition-api";
import { getTextHeight } from "../services/Canvas2DContext";
import { DefaultConfigs, IPadProConfigs } from "../services/DefaultConfigs";

function isConfigProperlyDefined(config) {
  if (!config) {
    return false;
  }

  if (config.y != null) {
    return true;
  }

  if (config.x1 != null && config.x2 != null && config.y1 != null && config.y2 != null) {
    return true;
  }

  console.warn(`The line trend config (${JSON.stringify(config)}) doesn't have either the ` +
    `"y" property or all of the following properties "x1", "x2", "y1", "y2" defined.`);

  return false;
}

function getDashArrayForLineType(lineType) {
  switch (lineType) {
    case "dashed":
      return "5,5";

    case "dotted":
      return "2,2";
  }
}

export default function useChartTrendLines(configRef, availableWidthRef, availableHeightRef, marginRef, xRef, yRef, xBandwidthRef, isIPadProRef) {
  const trendLines = ref([]);

  const updateTrendLines = () => {
    if (!configRef?.value || !xRef?.value || !yRef?.value) {
      trendLines.value = [];
      return;
    }

    const marginLeft = marginRef.value.left;
    const halfXBandwidth = xBandwidthRef.value / 2;

    let trendLinesConfig = configRef.value.trendLines;

    if (!Array.isArray(trendLinesConfig)) {
      trendLinesConfig = [trendLinesConfig];
    }

    trendLines.value = trendLinesConfig
      .filter(config => isConfigProperlyDefined(config))
      .map(config => {
        const {
          fontFamily = DefaultConfigs.TrendLines.fontFamily,
          fontSize = isIPadProRef?.value ? IPadProConfigs.TrendLines.fontSize : DefaultConfigs.TrendLines.fontSize,
          textColor = DefaultConfigs.TrendLines.textColor,
          textAnchor = DefaultConfigs.TrendLines.textAnchor,
          lineType = DefaultConfigs.TrendLines.lineType,
          color = DefaultConfigs.TrendLines.lineColor,
          dotRadius,
          y,
          x1, y1, x2, y2,
        } = config;

        const result = {
          color,
          fontFamily,
          fontSize,
          textColor,
          textAnchor,
          lineType,
          dotRadius,
          dashArray: getDashArrayForLineType(lineType),
          ...config.label,
        };

        if (y != null) {
          const textHeight = getTextHeight(`${fontSize}px ${fontFamily}`,
            result.text, DefaultConfigs.TrendLines.textMargin / 2);

          Object.assign(result, {
            x1: marginLeft,
            y1: yRef.value(y),
            x2: marginLeft + availableWidthRef.value,
            y2: yRef.value(y),
            labelX: marginLeft + DefaultConfigs.TrendLines.textMargin,
            labelY: yRef.value(y) + textHeight,
          });
        } else {
          Object.assign(result, {
            x1: xRef.value(x1) + halfXBandwidth,
            y1: yRef.value(y1),
            x2: xRef.value(x2) + halfXBandwidth,
            y2: yRef.value(y2),
          });
        }

        return result;
      });
  };

  watch([configRef, marginRef, availableWidthRef, availableHeightRef, xRef, yRef, isIPadProRef], updateTrendLines);

  onMounted(updateTrendLines);

  return { trendLines };
}
